import { useMemo } from "react";
import { useGetComments, useGetLogs, usePostComments } from "../../mutations";

export const useCommentsAndLogs = ({ topic, sub_event, object_id, parent_id, page = 1 }: { topic: string[]; sub_event: string[]; object_id: string | undefined; parent_id: string | undefined; page?: number }) => {

    const log = useGetLogs();
    const comments = useGetComments();
    const postComments = usePostComments();

    const getLogs = async (currentPage: number = page) => {
        const params = {
            topic: topic,
            sub_event: sub_event,
            object_id: object_id,
            parent_id: parent_id,
            page: currentPage,
            limit: 20
        }
        await log.mutateAsync(params);
    };

    const getComments = async (currentPage: number = page) => {
        const params = {
            object_type: sub_event,
            comment_topic: topic,
            object_id: object_id,
            parent_id: parent_id,
            page: currentPage,
            limit: 20
        }
        await comments.mutateAsync(params);
    };
    
    const postComment = async (comment: string) => {
        const payload: any = {
            ...(parent_id !== "" && { parent_id }),
            comment_topic: topic[0],
            object_id,
            object_type: sub_event[0],
            comment_text: comment,
        };
        await postComments.mutateAsync(payload);
        await getComments(1);
    };

    const commentsData = useMemo(
        () => (comments.isSuccess ? comments.data?.data?.rows || [] : []),
        [comments.isSuccess, comments.data?.data?.rows]
    );

    const logsData = useMemo(
        () => (log.isSuccess ? log.data?.data?.rows || [] : []),
        [log.isSuccess, log.data?.data?.rows]
    );

    return {
        getLogs,
        getComments,
        postComment,
        isCommentsPending: comments.isPending,
        isLogsPending: log.isPending,
        comments: commentsData,
        commentsPagination: comments.isSuccess ? comments.data?.data?.pagination : null,
        logs: logsData,
        logsPagination: log.isSuccess ? log.data?.data?.pagination : null,
        isAddingComment : postComments.isPending
    };

};